<template>
    <div
        class="o-searchresult searchresult"
        :class="{'searchresult__no-matches': !hasMatches || !hasStrictResult}"
    >
        <div
            v-if="!hasMatches"
            class="searchresult__text-item"
        >
            <span class="searchresult__text">
                {{ $t('searchresult__no-results') }}
            </span>
        </div>
        <div
            v-else-if="!hasStrictResult && !isLandscape"
            class="searchresult__text-item"
        >
            <span class="searchresult__text-no-matches">
                {{ $t('searchresult__no-matches') }}
                <!--&lt;!&ndash;No matches, you may be looking for it:&ndash;&gt;-->
            </span>
        </div>
        <RecycleScroller
            #default="{ item }"
            :items="items"
            :item-size="itemListSize"
            key-field=""
            class="searchresult__scroller"
        >
            <OWTilePlaceholder v-if="placeholders" />
            <OWItemTile
                v-else-if="t(item, 'type') === 'tenant'"
                :item="item"
                @onClick="handleClick"
            />
            <OWServiceInfoTile
                v-else-if="t(item, 'type') === 'service'"
                :item="item"
                @onClick="handleClick"
            />
            <OWServicesTile
                v-else
                :item="item"
                @onClick="handleClick"
            />
        </RecycleScroller>
    </div>
</template>

<script>
import { 
    mapGetters,
    mapState
} from 'vuex';

import OWItemTile from '../../organisms/o-w-item-tile/o-w-item-tile';
import OWServicesTile from '../../organisms/o-w-services-tile/o-w-services-tile';
import OWTilePlaceholder from '../../organisms/o-w-tile-placeholder/o-w-tile-placeholder';
import OWServiceInfoTile from '../../organisms/o-w-service-info-tile/o-w-service-info-tile';

export default {
    name: 'OSearchresult',
    components: {
        OWTilePlaceholder,
        OWItemTile,
        OWServicesTile,
        OWServiceInfoTile
    },
    data() {
        return {
            renderItems: 10
        }
    },
    props: {
        items: {
            type: [Array, Number],
            default: () => []
        },
        placeholders: {
            type: Boolean,
            default: false
        },
        hasStrictResult: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        ...mapState({
            isLandscape: state => state.landscape
        }),
        ...mapGetters([
            't'
        ]),
        hasMatches(){
            return this.items.length || this.placeholders
        },
        itemListSize() {
            return this.isLandscape ? 40 : 97
        }
    },
    methods: {
        handleClick(data) {
            this.$emit('onSearchTileClick', data);
        }
    }
}
</script>

<style lang="scss">
@import "o-searchresult";
</style>
